import { render, staticRenderFns } from "./NewRoleTemplateDialog.vue?vue&type=template&id=5cec003f&"
import script from "./NewRoleTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./NewRoleTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports